var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_vm._v("\n    Logout....\n")])}
var staticRenderFns = []

export { render, staticRenderFns }